import _extend from 'lodash/extend';
import _sortBy from 'lodash/sortBy';
import _reject from 'lodash/reject';

import membershipService from 'api/membership';
import MEMBERSHIP_STATUSES from 'constants/membershipStatuses';

function Ctrl($scope, $q, $rootScope, $stateParams, $state, $timeout, $location, utilsService, modalService, metaTagService, jsSdkUser, jsSdkMembership) {
  metaTagService.set({
    title: 'Edit Profile | Tablelist',
    description: 'Manage your VIP table bookings, make changes to your account and more.'
  });

  $scope.membership = null;
  $scope.MEMBERSHIP_STATUSES = MEMBERSHIP_STATUSES;

  loadMembership();

  $scope.editProfile = function() {
    modalService.editProfile();
  };

  $scope.editContactInformation = function() {
    modalService.editContactInformation();
  };

  $scope.editCreditCard = function() {
    modalService.editCreditCard();
  };

  $scope.editMembership = function() {
    modalService.editMembership({}, loadMembership);
  };

  $scope.cancelMembership = function() {
    $scope.errorMsg = null;

    modalService.confirmation({
        modalMessage: `Are you sure you want to cancel your Diamond Membership?<br>
          <p style="font-size: 14px; margin-top: 15px;">*Your membership will stop at the end of the month, at which point will no longer be able to redeem perks.</p>
          <p style="font-size: 14px; margin-top: 15px;">*Any future purchases of Diamond perks will be cancelled.</p>`,
        confirmBtnTxt: 'Yes',
        confirmingBtnTxt: 'Cancelling',
        cancelBtnTxt: 'No'
      })
      .then(result => {
        if (result && result.confirm) {
          $q.resolve(membershipService.actionById($scope.membership.id, {
              type: 'CANCEL'
            }))
            .then(membership => {
              _extend($scope.membership, membership);

              return jsSdkUser.me();
            })
            .then(currentUser => {
              _extend($rootScope.currentUser, currentUser);

              result.modalInstance.close();
            })
            .catch(err => {
              $scope.errorMsg = err.message;

              result.modalInstance.close();

              utilsService.scrollTo('account-error');
            });
        }
      });
  };

  $scope.enterPromo = function() {
    modalService.enterPromo();
  };

  $scope.editCities = function() {
    modalService.editCities();
  };

  $scope.forgotPassword = function() {
    modalService.forgotPassword();
  };

  if ($stateParams.action === 'payment') {
    $scope.editCreditCard();
  }

  if ($state.params.section === 'membership-section') {
    utilsService.scrollTo('membership-section', 100, 0, 400);
  }

  function loadMembership() {
    $scope.loading = true;

    jsSdkMembership.listByUserId(jsSdkUser.getCurrentUser().id, {})
      .then(resp => {
        $scope.loading = false;

        const memberships = _sortBy(_reject(resp, {
          status: MEMBERSHIP_STATUSES.CANCELLED
        }), 'created');

        if (memberships && memberships[0]) {
          $scope.membership = memberships[0];
        }

        if ($scope.membership.status === MEMBERSHIP_STATUSES.PAST_DUE && $state.params.pastDue) {
          $scope.editMembership();
        }
      })
      .catch(() => {
        $scope.loading = false;
      });
  }

  $scope.formatStatus = function(status) {
    if (!status) return '';

    return status.replace('_', ' ');
  };
}

Ctrl.$inject = [
  '$scope',
  '$q',
  '$rootScope',
  '$stateParams',
  '$state',
  '$timeout',
  '$location',
  'utilsService',
  'modalService',
  'metaTagService',
  'jsSdk.user',
  'jsSdk.membership'
];

export default Ctrl;



// WEBPACK FOOTER //
// ./src/components/accountProfile/accountProfileCtrl.js